import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface CloseEventArgs {
  abort?: () => void;
}

class CloseEvent extends EventData<Closeable> implements CloseEventArgs {
  abort?: () => void;

  constructor({ abort }: CloseEventArgs = {}) {
    super();

    this.abort = abort;
  }
}

class CloseEventListener extends EventListener<Closeable, CloseEvent, any> {
  constructor() {
    super(CloseEvent);
  }
}

export default interface Closeable extends Mountable {

  /** @event */
  onBeforeClose: CloseEventListener;

  /** @event */
  onClose: CloseEventListener;

  close(): void;

}

export { CloseEventListener, CloseEvent };
